import React, { ReactNode } from 'react';
import styled from 'styled-components';
import Navbar from './Navbar';
import Footer from './Footer';

interface LayoutProps {
  children: ReactNode;
  transparentHeader?: boolean;
  hideFooter?: boolean;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  transparentHeader = false,
  hideFooter = false,
}) => {
  return (
    <LayoutWrapper>
      <Navbar transparent={transparentHeader} />
      <Main>{children}</Main>
      {!hideFooter && <Footer />}
    </LayoutWrapper>
  );
};

const LayoutWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
  padding-top: 80px; // Height of navbar
`;

export default Layout;
